import { cn } from "@/lib/utils";
import { typographyVariantClass } from "@/lib/utils/theme-configuration-class";

export type BarPrefix = "topbar" | "navbar";

export type BlockAlignment = "default" | "left" | "center" | "right";

const alignmentClassMap: Record<BlockAlignment, string> = {
	default: "",
	left: "mr-auto",
	center: "mx-auto",
	right: "ml-auto",
};

export interface ResponsiveContainerBlock {
	id?: string | number | null;
	alignment?: BlockAlignment | null;
	stretch?: boolean | null;
	typographyVariant?: number | { id: number } | null;
}

export interface ResponsiveContainerProps {
	block: ResponsiveContainerBlock;
	barPrefix: BarPrefix;
	children: React.ReactNode;
	className?: string;
}

export function ResponsiveContainer({ block, barPrefix, children, className }: ResponsiveContainerProps): React.ReactElement {
	const blockClass = block.id != null ? `ms-${barPrefix}-block-${block.id}` : undefined;
	const alignmentClass = alignmentClassMap[block.alignment ?? "default"] ?? "";
	const fontClass = typographyVariantClass(block.typographyVariant);
	const stretch = block.stretch ?? false;

	return <div className={cn(blockClass, alignmentClass, stretch && "grow", fontClass, "flex", className)}>{children}</div>;
}
